// extracted by mini-css-extract-plugin
module.exports = {"icon":"ProfileIcon_icon__1ow9C"};